import { graphql } from "~/gql";

export const TOGGLE_FAVOURITE = graphql(/* GraphQL */ `
  mutation ToggleFavourite($id: Int!, $favourite: Boolean!) {
    toggleFavourite(id: $id, favourite: $favourite) {
      isFavourite
    }
  }
`);
